import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import store from "./store/store";
import {MsalProvider} from "@azure/msal-react";
import {PublicClientApplication} from "@azure/msal-browser";
import {msalConfig} from "./authConfig";
import * as Sentry from "@sentry/react";
import {isAuthRedirecting} from "./logic/authRedirect";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
export const pca = new PublicClientApplication(msalConfig);

if (window.config.sentryDsn) {
  Sentry.init({
    dsn: window.config.sentryDsn,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        networkDetailAllowUrls: ['.adaptivecatalog.dev/', '.adaptivecatalog.com/', '.managedcatalog.com/'],
        // The support login exchange answers with a live session key; keep its body out of every replay.
        networkDetailDenyUrls: [/\/keyAuth\/support\//i],
        maskAllText: false,
        stickySession: true,
      })
    ],
    // Tracing
    tracesSampleRate: 1.0, 
    tracePropagationTargets: ['.adaptivecatalog.dev/', '.adaptivecatalog.com/', '.managedcatalog.com/'],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    // Once a request has started the sign-in redirect (logic/authRedirect), the other requests already in flight
    // fail with "Not authenticated" and any un-caught .unwrap() among them rejects. The page is about to navigate
    // away and the user to sign in again, so those rejections aren't faults (AC-WEB-1).
    beforeSend(event) {
      const unhandledRejection = event.exception?.values?.some(v => v.mechanism?.type === 'onunhandledrejection');
      return unhandledRejection && isAuthRedirecting() ? null : event;
    },
  });
}

ReactDOM.render(
    <MsalProvider instance={pca}>
        <Provider store={store.store}>
            <BrowserRouter basename={baseUrl || ""}>
                <App/>
            </BrowserRouter>
        </Provider>
    </MsalProvider>,
  rootElement);

// ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
